module.exports = __webpack_public_path__ + "static/img/1.ab87e74.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer5/en/btn1/1.jpg
// module id = WeKk
// module chunks = 0